import { Pipe, PipeTransform } from '@angular/core';

/**
 * TT-260 items 4 and 6: show a VTI as its rank (Proficient) rather than the old
 * number (1.22). Same bands the backend scores with (VtiRatingService.getRank),
 * so the app, the VTI site and the Dashboard all agree.
 */
export const vtiRankFor = (value?: number | string | null): string => {
  const score = Number(value ?? 0);
  if (score < 0.25) return 'Rookie';
  if (score < 0.75) return 'Intermediate';
  if (score < 1.5) return 'Experienced';
  if (score < 2.5) return 'Proficient';
  if (score < 3.5) return 'Expert';
  if (score < 4.5) return 'Master';
  if (score < 5.25) return 'Artisan';
  return 'Elite Artisan';
};

@Pipe({ name: 'vtiRank' })
export class VtiRankPipe implements PipeTransform {
  transform(value?: number | string | null): string {
    return vtiRankFor(value);
  }
}
